module.exports = require('./src/normalizeWheel.js');



//////////////////
// WEBPACK FOOTER
// ./node_modules/.store/normalize-wheel@1.0.1/node_modules/normalize-wheel/index.js
// module id = JJNg
// module chunks = 4